<template>
  <div class="home" :class="{ pcStyle: isPc, mobileStyle: isMobile }"></div>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex';
  import ResizeMixin from '@/mixin/ResizeHandler';
  import H5Config from '@/config';

  export default {
    name: 'Home',
    mixins: [ResizeMixin],
    data() {
      return {};
    },
    created() {},
    mounted() {},
    methods: {},
  };
</script>
<style lang="less" scoped></style>
